var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.0002 18.0532V32.5C34.9999 32.9531 34.8771 33.3977 34.6448 33.7867C34.4126 34.1757 34.0795 34.4947 33.6808 34.7099C33.3196 34.9054 32.9143 35.0052 32.5036 34.9999H24.9947C24.6632 34.9999 24.3452 34.8682 24.1108 34.6338C23.8764 34.3993 23.7447 34.0814 23.7447 33.7499V26.2488C23.7447 25.9173 23.613 25.5993 23.3786 25.3649C23.1442 25.1305 22.8262 24.9988 22.4947 24.9988H17.4947C17.1632 24.9988 16.8452 25.1305 16.6108 25.3649C16.3764 25.5993 16.2447 25.9173 16.2447 26.2488V33.7499C16.2447 34.0814 16.113 34.3993 15.8786 34.6338C15.6442 34.8682 15.3262 34.9999 14.9947 34.9999H7.50048C7.14606 35.0008 6.79554 34.9259 6.47241 34.7803C6.14928 34.6347 5.861 34.4217 5.62689 34.1557C5.21592 33.6803 4.99301 33.0711 5.00017 32.4428V18.053C5.00044 17.7047 5.07335 17.3603 5.21425 17.0417C5.35514 16.7232 5.56092 16.4375 5.81845 16.203L18.3174 4.83846C18.7765 4.41792 19.3765 4.18463 19.9991 4.18457C20.6217 4.18451 21.2218 4.41769 21.681 4.83815L34.182 16.2032C34.4395 16.4377 34.6452 16.7234 34.7861 17.0419C34.927 17.3605 34.9999 17.7049 35.0002 18.0532Z",
    fill: "#A4C3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 25.3906C15.625 23.0175 17.5488 21.0938 19.9219 21.0938C22.295 21.0938 24.2188 23.0175 24.2188 25.3906V35H15.625V25.3906Z",
    fill: "#6AA287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29.5312H17.1875V35H7C5.89543 35 5 34.1046 5 33V29.5312Z",
    fill: "#6AA287"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29.5312H17.1875V35H33C34.1046 35 35 34.1046 35 33V29.5312Z",
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency);
export default __webpack_public_path__ + "static/media/agency.06949a78b1eeacfdbac7dcffdc6e5cd0.svg";
export { ForwardRef as ReactComponent };